// extracted by mini-css-extract-plugin
export default {"overlay":"overlay--j5utDwD9Ty"};